import { Group, NumberInput, Text, TextInput, Button, Textarea } from '@mantine/core';
import { 
  TableCell,
  TableRow as Tr,
  Table,
  TableBody
} from '@material-ui/core';
import { formatNumber, formatNumberByLocale, formatUnit } from '../../../helpers/stringsManipulations';
import { useEffect, useState } from 'react';
import Icon from '../../../components/Icon';
import { DatePicker } from '@mantine/dates';
import 'dayjs/locale/de';
import { CustomModal, MeterModal } from '../../../neoverv';
import Autoload from '../../../neoverv/Autoload';
import { NumericFormat, numericFormatter } from 'react-number-format';
import accounting from 'accounting';
import TruncatedTextHandler from '../../../components/TruncatedTextHandler';
import MeterDataHandler from '../../../neoverv/helpers/DataHandler/Meter';
import { config } from '../../../neoverv/config/Setting';
import GreenTick from '../../../assets/images/module/general/GreenTick.svg';
import RedCross from '../../../assets/images/module/general/GreenTick.svg';
import { showNotification } from '@mantine/notifications';
import APIClient from '../../../neoverv/config/APIClient';


const tableMobileBodyCellStyling = {
  color: 'rgb(17, 17, 71)',
  padding: '6px',
  fontWeight: '400',
  whiteSpace: 'wrap',
  fontSize: '14px',
  lineHeight: '20px',
  border: 'none',
  textTransform: 'capitalize',
  fontFamily: 'Inter, sans-serif',
  textAlign: 'right',
  height: '40px',
  display: 'flex',
  marginTop: '4px',
  alignItems: 'center',
  width: '50vw',
  justifyContent: 'flex-end'
}

const tableHeadCellStyling = {
  color: 'rgb(73, 80, 87)',
  padding: '6px',
  fontWeight: '500',
  whiteSpace: 'nowrap',
  fontSize: '14px',
  lineHeight: '20px',
  border: 'none',
  textTransform: 'capitalize',
  fontFamily: 'Inter, sans-serif',
  display: 'flex',
  height: '40px',
  marginTop: '4px',
  alignItems: 'center'
}

const tableMobileRow = {display: 'flex', justifyContent: 'space-between'}
const MeterIcon = "data:image/svg+xml;base64,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";
const TableRow = ({ 
  subIndex, 
  rowReading, 
  occasionDate, 
  end, 
  consumption,
  editableIds,
  isMobile,
  onConsumptionChange,
  onLastReadingEdit, 
  onCurrentReadingEdit, 
  onDateChange, 
  onNotesEdit,
  search,
  startValue,
  currentValue,
  handleDataSaving,
  disableMobileUpdate,
  onBlur,
  print= false,
  hkEnabled,
  getOccupationReadings,
  propertySelected,
  history
 }) => {
  
  const [openModal, setOpenModal] = useState(false);
  const [openMeterEditModal, setOpenMeterEditModal] = useState(false);
  const [reading, setReading] = useState(rowReading);
  const [lastReadingInFocus, setLastReadingInFocus] = useState(false);
  const [currentReadingInFocus, setCurrentReadingInFocus] = useState(false);

  const [lastValue, setLastValue] = useState('');

  const [notesInFocus, setNotesInFocus] = useState(false);
  //const [currentValue, setCurrentValue] = useState();
  // useEffect(() => {
  //   onConsumptionChange(consumption, subIndex);
  // }, [consumption]);
  console.log('occasion: ', hkEnabled);
  console.log('values: ', startValue, currentValue);
  console.log('reading: ', reading);
  const resolveNumericValue = (val) => (val === '' || val === null || val === undefined) ? null : val;
  const tableBodyCellStyling = print ?
  {
    color: '#0e0e1d',
    padding: '0px 3px',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    margin: '0px',
    fontSize: '7pt',
    lineHeight: '18px',
    border: '1px solid #DADAE6',
    textTransform: 'capitalize',
    height: '0px',
    minWidth: '40px'
  }
  : 
  {
    color: 'rgb(17, 17, 71)',
    padding: '6px',
    fontWeight: '400',
    whiteSpace: 'wrap',
    fontSize: '14px',
    lineHeight: '18px',
    border: '1px solid #DADAE6',
    textTransform: 'capitalize',
    fontFamily: 'Inter, sans-serif',
    height: print && '48px',
    wordWrap: 'break-word',     /* Ensures long words wrap */
    wordBreak: 'break-word',    /* Ensures long words break to fit */
    overflowWrap: 'break-word', /* Ensures long words wrap within the cell */
    hyphens: 'auto'
  }

  const onBlurForStartValue=(e)=>{
    let newStartValue = {
      id: startValue?.id,
      value: e.target.value.length === 0 ? null : accounting.unformat(e.target.value, ',')
    };//Autoload.MainHelper.ConvertCurrencDe_BackToNumber(numericFormatter(e.target.value.replaceAll('.', '').replace(',', '.'), {thousandSeparator: ',', decimalSeparator: '.'}));
    console.log('onBlurStartValue: ', newStartValue, e.target.value.length);
    if(currentValue === '' || startValue?.value === null || currentValue === null || startValue?.value === ''){
      onLastReadingEdit(newStartValue, subIndex, true, reading?.meter?.id);
      onBlur(false);  
    } else {
      onLastReadingEdit(newStartValue, subIndex, true, reading?.meter?.id);
      onBlur(currentValue < startValue?.value);  
    }
    setLastReadingInFocus(false);
  }

  const onBlurForCurrentReading=(e)=> {
    let newCurrentValue = e.target.value.length === 0 ? null : accounting.unformat(e.target.value, ',');//Autoload.MainHelper.ConvertCurrencDe_BackToNumber(numericFormatter(e.target.value.replaceAll('.', '').replace(',', '.'), {thousandSeparator: ',', decimalSeparator: '.'}));
    console.log('onBlurCurrentValue: ', newCurrentValue, e.target.value, accounting.unformat(e.target.value));
    if(currentValue === '' || startValue?.value === null || currentValue === null || startValue?.value === ''){
      onCurrentReadingEdit(newCurrentValue, subIndex, true, reading?.meter?.id);
      onBlur(false);
    } else {
      onCurrentReadingEdit(newCurrentValue, subIndex, true, reading?.meter?.id);
      console.log('currentValue_234: ', currentValue);
      onBlur(end ? false : hkEnabled ? false : currentValue < startValue?.value);
    }
    setCurrentReadingInFocus(false);
  }
  console.log('reading.meter:', reading?.meter)

  console.log('consumption: ', consumption);
  useEffect(() => {
    setReading(rowReading);
  }, [rowReading]);

  const lastReadingEditor=()=> <NumericFormat 
  className={`form-control form-control-meter-readings ${hkEnabled && 'meter-reading-start-value-disabled'}`}
  id={`meter-readings-last-reading-input-${reading.id}`}
  style={{textAlign: 'right', height: '100%', paddingRight: 0}}
  value={hkEnabled ? 0 : (startValue?.value || startValue?.value === 0) ? startValue?.value : ''}
  thousandSeparator="." 
  decimalSeparator=","
  onValueChange={(values) => {
    const newValue = (values.floatValue || values.floatValue === 0) ? values.floatValue : null;
    if (newValue !== resolveNumericValue(startValue?.value)) {
      onLastReadingEdit({ id: startValue?.id, value: newValue }, subIndex, false, reading?.meter?.id);
    }
  }}
  onFocus={()=> setLastReadingInFocus(true)}
  onBlur={onBlurForStartValue}
  //onKeyPress={this.handleEnterKeyPress}
  //placeholder='0,00'
  suffix=''
  decimalScale={5}
  fixedDecimalScale={false}
  allowNegative={false}
  disabled={hkEnabled}
  />;

  const currentReadingEditor=()=> <NumericFormat 
  className='form-control form-control-meter-readings'
  id={`meter-readings-current-reading-input-${reading.id}`}
  style={{textAlign: 'right', height: '100%', paddingRight: 0}}
  value={(currentValue || currentValue === 0) ? currentValue : ''}
  thousandSeparator="." 
  decimalSeparator=","
  onValueChange={(values) => {
    const newValue = (values.floatValue || values.floatValue === 0) ? values.floatValue : null;
    if (newValue !== resolveNumericValue(currentValue)) {
      onCurrentReadingEdit(newValue, subIndex, false, reading?.meter?.id);
    }
  }}
  onFocus={()=> setCurrentReadingInFocus(true)}
  onBlur={onBlurForCurrentReading}
  //onKeyPress={this.handleEnterKeyPress}
  //placeholder='0,00'
  suffix=''
  decimalScale={5}
  fixedDecimalScale={false}
  allowNegative={false}
  />;

  const handleLastReadingInFocus=()=>{
    setLastReadingInFocus(true);
  }

  const handleCurrentReadingInFocus=()=>{
    setCurrentReadingInFocus(true);
  }

  useEffect(() => {
    if (lastReadingInFocus) {
      document.getElementById(`meter-readings-last-reading-input-${reading.id}`)?.focus();
    }
  }, [lastReadingInFocus]);

  useEffect(() => {
    if (currentReadingInFocus) {
      document.getElementById(`meter-readings-current-reading-input-${reading.id}`)?.focus();
    }
  }, [currentReadingInFocus]);

  const toggleMeterEditModal=()=>{
    setOpenMeterEditModal(!openMeterEditModal);
  }

  const handleEdit = async (updatedData) => {
    console.log('handleEdit: ', updatedData);
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'block';
    updatedData.rentalUnitId = updatedData.meterType === 'PROPERTY' ? null : updatedData.rentalUnitId;
    updatedData.rentalUnitName = updatedData.meterType === 'PROPERTY' ? null : updatedData.rentalUnitName;
    const payload = MeterDataHandler.generateMeterDatawithAllocationKey(updatedData);
    console.log(payload, 'payload edit data');
    
    await APIClient({
      method: 'PUT',
      url: config?.meter + 'meters/' + updatedData.id,
      data: payload,
      headers: { Authorization: Autoload.Utils.getAuthToken() }
    })
      .then((respone) => {
        console.log('APIClient: ', respone);
        toggleMeterEditModal();
        loader.style.display = 'none';
        getOccupationReadings();
        showNotification({
          message: 'Die Änderungen wurden übernommen.',
          icon: <img src={GreenTick} alt='green-tick'/>
        })
      })
      .catch((error) => {
        if(error.toString().includes('409')){
          showNotification({
            id: 'meterDuplicate',
            //title: 'Fehler',
            message: "Diese Zählernummer wird bereits verwendet. Bitte wählen Sie eine andere Zählernummer.",
            icon: <img src={RedCross} alt='red-tick'/>,
            //style: {marginLeft: !isMobile && !isTablet && '24%', width: '100%'},
          });
          loader.style.display = 'none';
        }else{
          console.log('APIClient: ', error);
          toggleMeterEditModal();        
          loader.style.display = 'none';
          showNotification({
            message: "Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.",
            icon: <img src={RedCross} alt='red-tick'/>,
            //style: {marginLeft: !isMobile && !isTablet && '24%', width: '100%'},
          });
        } 
      });
  };
  return (
    <>
      {isMobile ?
      <>
        <Tr style={{height: '80px'}} onClick={() => setOpenModal(!openModal)}>
          <TableCell style={{
            maxWidth: '25vw', 
            textTransform: 'none',
            fontFamily: 'Inter, sans-serif',
            border: 'none',
            padding: '2px 16px',
            borderTopLeftRadius: '3px',
            borderBottomLeftRadius: '3px'
            }}><Text 
            className='meter-reading-row-p'
            style={{
              textOverflow: 'ellipsis', 
              overflow: 'hidden',
              color: '#111147' 
            }}>{reading?.meter?.meterNo}</Text></TableCell>
          <TableCell style={{
            maxWidth: '32vw',
            textTransform: 'none',
            lineHeight: '30px',
            padding: '2px 16px',
            fontFamily: 'Inter, sans-serif',
            border: 'none',
            }}><Text 
            className='meter-reading-row-p'
            style={{
              textOverflow: 'ellipsis', 
              overflow: 'hidden', 
              color: '#111147'
            }}>{reading?.meter?.allocationKey.allocationKeyName}</Text>
          </TableCell>
          
          {/* Ablesewert / meter reading */}
          <TableCell style={{
            border: 'none',
            //backgroundColor: reading.currentValue < reading.startValue?.value && 'rgba(232, 25, 60, .1)',
            padding: '2px 16px',
            borderTopRightRadius: '3px',
            borderBottomRightRadius: '3px',
            }}>
            <NumberInput
              variant="unstyled"
              styles={{ input: { textAlign: 'right', color: currentValue < startValue?.value ? '#D41636' : '#111147', } }}
              // parser={(value) => value.replace(/\$\s?|(,*)/g, '')} 
              precision={2}
              decimalSeparator=","
              min={0}
              value={currentValue}
              hideControls
              //placeholder='0,00'
              onChange={(value) => onCurrentReadingEdit(value, subIndex, end, reading?.meter?.id)}
            />
          </TableCell>
        </Tr>
        <CustomModal
            open={openModal}
            toggle={() => setOpenModal(!openModal)}
            heading="Zählerablesung"
            className="mobile-meter-detail-modal"
            style={{margin: window.innerWidth < 500 && 5}}
          >
            <Table>
                <TableBody>
                  <Tr style={tableMobileRow}>
                    <TableCell style={{...tableHeadCellStyling, ...{padding: '6px 16px 6px 0px'}}}>Nummer</TableCell>
                    <TableCell style={{...tableMobileBodyCellStyling, ...{textTransform: 'none', padding: '6px 0px 6px 16px'}}}><Text className='meter-reading-row-p'>{reading?.meter?.meterNo}</Text></TableCell>
                  </Tr>
                  <Tr style={tableMobileRow}>
                    <TableCell style={{...tableHeadCellStyling, ...{padding: '6px 16px 6px 0px'}}}>Art</TableCell>
                    <TableCell style={{...tableMobileBodyCellStyling, ...{textTransform: 'none', padding: '6px 0px 6px 16px'}}}><Text className='meter-reading-row-p'>{reading?.meter?.allocationKey?.allocationKeyName}</Text></TableCell>
                  </Tr>
                  <Tr style={tableMobileRow}>
                    <TableCell style={{...tableHeadCellStyling, ...{padding: '6px 16px 6px 0px'}}}>Standort</TableCell>
                    <TableCell style={{...tableMobileBodyCellStyling, ...{padding: '6px 0px 6px 16px'}}}><Text className='meter-reading-row-p'>{reading?.meter?.location}</Text></TableCell>
                  </Tr>
                  {/* <Tr style={tableMobileRow}>
                    <TableCell style={{...tableHeadCellStyling, ...{}}}>Ablesedatum</TableCell>
                    <TableCell style={{...tableMobileBodyCellStyling, ...{padding: '2px', display: 'flex', justifyContent: 'flex-end'}}} className="reduceSidePaddings">
                      
                          <DatePicker 
                            locale="de"
                            value={new Date(occasionDate)}
                            icon={<Icon name="calendar" />}
                            variant="unstyled"
                            inputFormat="DD.MM.YYYY"
                            allowFreeInput={true}
                            clearable={false}
                            onChange={(value) => onDateChange(value, subIndex)}
                            zIndex={10000}
                            styles={{
                              root: {
                                width: '70%',
                              },
                              input: {
                                textAlign: 'end',
                                paddingRight: '16px',
                              }
                            }}
                            shouldCloseOnSelect={false}
                          />
                      
                    </TableCell>
                  </Tr> */}
                  
                    <Tr style={tableMobileRow}>
                      
                    <TableCell style={{...tableHeadCellStyling, ...{padding: '6px 16px 6px 0px'}}}>Startwert</TableCell>

                      <TableCell 
                        style={{...tableMobileBodyCellStyling, ...{padding: '6px 5px 6px 16px', backgroundColor: end ? (editableIds.length ? (editableIds.length && editableIds.find((id)=> reading.id === id) ? "rgba(242, 242, 252, 1)" : "rgba(242, 242, 252, 1)") : "rgba(242, 242, 252, 1)") : "rgba(242, 242, 252, 1)"}}}>
                        {end ?
                        '-'
                        :
                        <NumberInput
                          variant="unstyled"
                          styles={{ input: { textAlign: 'right', color: startValue?.value === null && lastValue === '' && '#adb5bd' } }}
                          precision={2}
                          decimalSeparator=","
                          min={0}
                          value={(startValue?.value || startValue?.value === 0) ? startValue?.value : undefined}
                          //placeholder='0,00'
                          hideControls
                          //disabled={end ? (editableIds.length ? (editableIds.length && !editableIds.find((id)=> reading.id === id)) : false) : false}
                          onBlur={onBlurForStartValue}
                          onChange={(value) => (value || value === 0) ? Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(value.toString() + '', false) !== Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(startValue?.value + '', false) ? onLastReadingEdit({ id: startValue?.id, value }, subIndex, false, reading?.meter?.id)
                          :
                          startValue?.value !== 0 && Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(value.toString() + '', false) === '0,00' ? onLastReadingEdit({ id: startValue?.id, value }, subIndex, false, reading?.meter?.id) : null
                          : (startValue?.value !== null && startValue?.value !== undefined) && onLastReadingEdit({ id: startValue?.id, value: null }, subIndex, false, reading?.meter?.id)}
                        />}
                      </TableCell>
                    </Tr>
                    <Tr style={tableMobileRow}>
                      <TableCell style={{...tableHeadCellStyling, ...{padding: '6px 16px 6px 0px'}}}>Ablesewert</TableCell>
                      <TableCell style={{...tableMobileBodyCellStyling, ...{padding: '6px 5px 6px 16px', backgroundColor: currentValue !== null && currentValue < startValue?.value ? 'rgba(232, 25, 60, .1)' : 'rgba(242, 242, 252, 1)'}}}>
                        <NumberInput
                          variant="unstyled"
                          className='current-readings-value'
                          styles={{ input: { textAlign: 'right', color: currentValue !== null && (currentValue < startValue?.value ? '#D41636' : '#111147'), } }}
                          precision={2}
                          decimalSeparator=","
                          min={0}
                          value={(currentValue || currentValue === 0) ? currentValue : undefined}
                          hideControls
                          //placeholder='0,00'
                          onChange={(value) => (value || value === 0) ? Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(value.toString() + '', false) !== Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(currentValue + '', false) ? onCurrentReadingEdit(value, subIndex, false, reading?.meter?.id)
                          :
                          currentValue !== 0 && Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(value.toString() + '', false) === '0,00' && Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(currentValue + '', false) === '0,00' && onCurrentReadingEdit(value, subIndex, false, reading?.meter?.id)
                          : (currentValue !== null && currentValue !== undefined) && onCurrentReadingEdit(null, subIndex, false, reading?.meter?.id)}
                          // onBlur={(e)=> e.target.value === '' || startValue?.value === null ? onBlur(false) : onBlur(e.target.value < startValue?.value)}
                          onBlur={onBlurForCurrentReading}
                        />
                      </TableCell>
                    </Tr>
                    <Tr style={tableMobileRow}>
                      <TableCell style={{...tableHeadCellStyling, ...{padding: '6px 16px 6px 0px'}}}>Verbrauch</TableCell>
                      <TableCell style={{...tableMobileBodyCellStyling, ...{
                        //backgroundColor: consumption < 0 ? 'rgba(232, 25, 60, .1)' : 'transparent',
                        padding: '6px 0px 6px 16px',
                        color: consumption < 0 ? '#D41636' : '#111147',
                        fontWeight: 'bold',
                        textAlign: 'right',
                        textTransform: 'none'
                      }}}><Text className='meter-reading-row-p'>{end ? '-' : consumption !== null && formatNumberByLocale(consumption) +' '+ formatUnit(reading?.meter?.allocationKey.units)}</Text></TableCell>
                    </Tr>
                    <Tr style={tableMobileRow}>
                      <TableCell style={{...tableHeadCellStyling, ...{width: "auto", padding: '6px 16px 6px 0px'}}}>Notiz</TableCell>
                    </Tr>
                    <Tr>
                      <TableCell style={{textTransform: 'none', height: 'auto', justifyContent: 'space-around', border:'none', padding: '16px 0px'}}>
                        <TextInput placeholder="Hinzufügen" style={{border: '1px solid #DADAE6', borderRadius: '3px', padding: '5px', width: '100%'}} variant="unstyled" value={reading.notes} onChange={(event) => event.target.value !== reading.notes && onNotesEdit(event.target.value, subIndex)} onBlur={()=> currentValue === '' || startValue?.value === '' ? onBlur(false) : onBlur(currentValue < startValue?.value)} />
                      </TableCell>
                    </Tr>
                  </TableBody>
                </Table>
                <Group style={{display: isMobile && 'flex', justifyContent: isMobile && 'space-between', width: isMobile && '100%', marginTop: '10px'}}>
                  <Button variant="white" onClick={() => setOpenModal(false)}>Abbrechen</Button>
                  <Button variant="filled" disabled={disableMobileUpdate} onClick={handleDataSaving}>Speichern</Button>
                </Group>
          </CustomModal>
      </>
      :
      <Tr>
        <TableCell onClick={()=> toggleMeterEditModal()} style={{...tableBodyCellStyling, ...{textTransform: 'none', borderRight: print && 'none', cursor: 'pointer'}}}>
          {print ?
          <div style={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'center'}}>
            <img src={MeterIcon} alt='meter-icon' style={{maxWidth: '7px', marginRight: '5px'}}/>
            <Text className='meter-reading-row-p' style={{lineHeight: print && '12px'}}>{reading?.meter?.meterNo}</Text>
          </div>
          :
          <Group wrap="nowrap" align={'center'} gap={7}>
            <img src={MeterIcon} alt='meter-icon'/>
            <Text className='meter-reading-row-p' style={{lineHeight: print && '12px'}}>{reading?.meter?.meterNo}</Text>
          </Group>}
        </TableCell>
        <TableCell style={{...tableBodyCellStyling, ...{textTransform: 'none', borderRight: print && 'none'}}}><Text className='meter-reading-row-p' style={{lineHeight: print && '12px'}}>{reading?.meter?.meterName}</Text></TableCell>
        <TableCell style={{...tableBodyCellStyling, ...{whiteSpace: 'normal', textTransform: 'none', borderRight: print && 'none'}}}><Text className='meter-reading-row-p' style={{lineHeight: print && '12px'}}>{reading?.meter?.allocationKey?.allocationKeyName}</Text></TableCell>
        <TableCell style={{...tableBodyCellStyling, ...{borderRight: print && 'none'}}}><Text className='meter-reading-row-p' style={{lineHeight: print && '12px'}}>{reading?.meter?.location}</Text></TableCell>
        {/*<TableCell style={{...tableBodyCellStyling, ...{padding: '2px'}}} className="reduceSidePaddings">
          <DatePicker 
            locale="de"
            //value={new Date(occasionDate)}
            value={new Date(reading.meterReadingDate)}
            icon={<Icon name="calendar" />}
            variant="unstyled"
            inputFormat="DD.MM.YYYY"
            allowFreeInput={true}
            clearable={false}
            onChange={(value) => onDateChange(value, subIndex, reading.meter.id)}
          />
          </TableCell>*/}

        {/* Editable number fields */}
        {/* Startwert / Last value */}
        {/* TODO: Numbers format needed: 1.234.567.89 */}
        {!end &&
          <TableCell
          onClick={(!print && !lastReadingInFocus) ? (()=> hkEnabled === false && handleLastReadingInFocus()) : undefined}
          style={{...tableBodyCellStyling, ...{borderBottom: print && '1px solid #DADAE6', borderRight: print && 'none', backgroundColor: print ? 'white' : (end && editableIds.length) ? (editableIds.length && editableIds.find((id)=> reading.id === id) ? (hkEnabled ? 'white' : "rgba(242, 242, 252, 1)") : (hkEnabled ? 'white' : "rgba(242, 242, 252, 1)")) : end ? 'white' : (hkEnabled ? 'white' : "rgba(242, 242, 252, 1)"), cursor: (!print && !lastReadingInFocus && hkEnabled === false) && 'pointer'}}}>
          {print ?
          <Text className='meter-reading-row-p' style={{textAlign: 'right', lineHeight: print && '12px'}}>{reading?.meter?.hkaEvaluationFactor !== null ? `${hkEnabled ? accounting.formatNumber(0, 2, '.', ',') : (startValue?.value || startValue?.value === 0) ? accounting.formatNumber(startValue?.value, 2, '.', ',') : ''} ${(startValue?.value || startValue?.value === 0 || hkEnabled) ? '/' : '-'} ${hkEnabled ? accounting.formatNumber((0 * reading?.meter?.hkaEvaluationFactor), 2, '.', ',') : (startValue?.value || startValue?.value === 0) ? accounting.formatNumber((startValue?.value * reading?.meter?.hkaEvaluationFactor), 2, '.', ',') : ''}` : (hkEnabled ? accounting.formatNumber(0, 2, '.', ',') : (startValue?.value || startValue?.value === 0) ? accounting.formatNumber(startValue?.value, 2, '.', ',') : '-')}</Text>
          :
          <>
          {end ?
          <Text className='meter-reading-row-p' style={{textAlign: 'right', lineHeight: print && '12px'}}>{'-'}</Text>
          :
          lastReadingInFocus ?
          lastReadingEditor()
          :
          <Text className='meter-reading-row-p' style={{textAlign: 'right', lineHeight: print && '12px', minHeight: '18px'}}>{reading?.meter?.hkaEvaluationFactor !== null ? `${hkEnabled ? accounting.formatNumber(0, 2, '.', ',') : (startValue?.value || startValue?.value === 0) ? accounting.formatNumber(startValue?.value, 2, '.', ',') : ''} / ${hkEnabled ? accounting.formatNumber((0 * reading?.meter?.hkaEvaluationFactor), 2, '.', ',') : (startValue?.value || startValue?.value === 0) ? accounting.formatNumber((startValue?.value * reading?.meter?.hkaEvaluationFactor), 2, '.', ',') : ''}` : (hkEnabled ? accounting.formatNumber(0, 2, '.', ',') : (startValue?.value || startValue?.value === 0) ? accounting.formatNumber(startValue?.value, 2, '.', ',') : '')}</Text>
          }
          </>
          }
        </TableCell>}

        {/* Ablesewert / meter reading */}
        <TableCell
          onClick={(!print && !currentReadingInFocus) ? (()=> handleCurrentReadingInFocus()) : undefined}
          style={{...tableBodyCellStyling, ...{
          borderBottom: print && '1px solid #DADAE6',
          borderRight: print && 'none', backgroundColor: print ? 'white' : (currentValue !== null && currentValue < startValue?.value && !end && !hkEnabled) ? 'rgba(232, 25, 60, .1)' : 'rgba(242, 242, 252, 1)',
          cursor: (!print && !currentReadingInFocus) && 'pointer'
          }}}>
          {print ?
          <Text className='meter-reading-row-p' style={{textAlign: 'right', lineHeight: print && '12px'}}>{(currentValue || currentValue === 0) ? reading?.meter?.hkaEvaluationFactor !== null ? `${accounting.formatNumber(currentValue, 2, '.', ',')} / ${accounting.formatNumber(currentValue * reading?.meter?.hkaEvaluationFactor, 2, '.', ',')}` : (currentValue || currentValue === 0) ? formatNumber(currentValue) : '-' : '-'}</Text>
          :
          currentReadingInFocus ?
          currentReadingEditor()
          :
          <Text className='meter-reading-row-p' style={{textAlign: 'right', lineHeight: print && '12px', minHeight: '18px'}}>{(currentValue || currentValue === 0) ? (reading?.meter?.hkaEvaluationFactor !== null ? `${accounting.formatNumber(currentValue, 2, '.', ',')} / ${accounting.formatNumber(currentValue * reading?.meter?.hkaEvaluationFactor, 2, '.', ',')}` : formatNumber(currentValue)) : ''}</Text>
          }
        </TableCell>

        {!end &&
        <TableCell style={{...tableBodyCellStyling, ...{
          borderRight: print && 'none',
          backgroundColor: consumption < 0 ? 'rgba(232, 25, 60, .1)' : 'transparent',
          color: consumption < 0 ? '#D41636' : '#111147',
          textAlign: 'right'
        }}}><Text className='meter-reading-row-p' style={{lineHeight: print && '12px'}}>{end ? '-' : 
                    isNaN(consumption) ? null : 
                      consumption !== null ? reading?.meter?.hkaEvaluationFactor !== null ? //print ? `${accounting.formatNumber(currentValue - startValue.value, 2, '.', ',')} / ${accounting.formatNumber((currentValue * reading.meter.hkaEvaluationFactor) - (startValue.value * reading.meter.hkaEvaluationFactor), 2, '.', ',')}` : 
                      `${accounting.formatNumber(consumption, 2, '.', ',')} / ${accounting.formatNumber(consumption * reading?.meter?.hkaEvaluationFactor, 2, '.', ',')}` : 
                        formatNumber(consumption) : 
                          print && '-'}</Text></TableCell>}
        <TableCell style={{...tableBodyCellStyling, ...{textTransform: 'none', borderRight: print && 'none', whiteSpace: print ? 'nowrap' : 'normal', minWidth: print ? 'auto' : '40px'}}}><Text className='meter-reading-row-p' style={{lineHeight: print && '12px'}}>{reading?.meter?.allocationKey.systemAllocationKeyId === '17749a71-7aa8-4920-9773-b6c218504ba3' ? (reading?.meter?.hkaEvaluationFactor !== null ? 'Einheits- / Produktskala' : 'Produktskala') : formatUnit(reading?.meter?.allocationKey.units)}</Text></TableCell>
        <TableCell colSpan={end && 3} style={{...tableBodyCellStyling, ...{whiteSpace: print ? 'normal' : 'nowrap'}}}>
          {print ?
          <Text className='meter-reading-row-p' style={{textTransform: 'none', lineHeight: '12px'}}>{reading.notes}</Text>
          :
          <Textarea 
          className='meter-reading-notes'
          placeholder="Hinzufügen" 
          variant="unstyled" 
          value={reading.notes} 
          autosize
          minRows={1}
          maxRows={2}
          onChange={(event) => event.target.value !== reading.notes && onNotesEdit(event.target.value, subIndex, reading?.meter?.id)} 
          onBlur={()=> currentValue === '' || startValue?.value === '' ? onBlur(false) : onBlur(currentValue < startValue?.value)}
          />}</TableCell>
      </Tr>}
      {openMeterEditModal &&
      <MeterModal
      history={history}
      record={reading?.meter}
      className="add-edit-receipt-modal meter-edit-modal"
      currentMeter={0}
      edit={true}
      open={openMeterEditModal}
      handleEdit={(updatedData) => handleEdit(updatedData)}
      toggle={() => toggleMeterEditModal()}
      propertyId={propertySelected && propertySelected.id}
    />}
    </>
  )
}

export default TableRow